import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate';
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    activeItem: {},
    activeSubStatusItem: {},
    layoutName: 'default',
    selectedDates: {from: '', upto: ''},
    activeTitle: '',
    sDefaults: {tab: 'today', rSt: 1, rEnd: 0, searchFn: null},
    uDefaults: {tab: 'today', rSt: 1, rEnd: 0, searchFn: null},
    eDefaults: {tab: 'today', rSt: 1, rEnd: 0, searchFn: null},
    selectedProjects: [],
    selectedSources: [],
    selectedManager: null,
    executive: '',
    isLoading: true,
    substatus: [],
    status: [],
    exeusers: [],
    third_parties: [],
    multiManger: [],
    runo_user: '',
    todays_call: '',
    enquiry: '',
    take_rate_from: null,
    take_rate_upto: null,
    average_ticket_size_from: null,
    average_ticket_size_upto: null,
    revenue_from: null,
    revenue_upto: null,
    active_user:  null,
    is_star_project: null,
    cities: [],
    subProjects: [],
    selectedAdGroups: [],
    selectedCampaigns: [],
    physical_pincode: [],
    mtrReportFilters: null,
    ad_strategies: [],
    ads_names: [],
    devices: [],
    keyword_types: [],
    utm_campaigns: []

  },
  mutations: {
    setLayout(state, layout){
      state.layoutName = layout
    },
    setActiveItem(state, item){
      state.activeItem = item
    },
    setSubStatusActiveItem(state, item){
      state.activeSubStatusItem = item;
    },
    setDefaultDates(state, dates){
      state.selectedDates = dates
    },
    setActiveTitle(state, title){
      state.activeTitle = title
    },
    setSelectedProjects(state, list){
      state.selectedProjects = list
    },
    addProject(state, project){
      state.selectedProjects.push(project)
    },
    removeProject(state, project){
      let index = state.selectedProjects.indexOf(project);
      state.selectedProjects.splice(index, 1)
    },
    setSelectedSources(state, list){
      state.selectedSources = list
    },
    setSelectedManager(state, managerId){
      state.selectedManager = managerId
    },
    setExecutive(state, execid){
      state.executive = execid
    },
    setSubStatus(state, ss){
      state.substatus = ss
    },
    setStatus(state, s){
      state.status = s
    },
    setTakeRateFrom(state, trf){
      state.take_rate_from = trf
    },
    setTakeRateUpto(state, tru){
      state.take_rate_upto = tru
    },
    setTicketSizeFrom(state, tsf){
      state.average_ticket_size_from = tsf
    },
    setTicketSizeUpto(state, tsu){
      state.average_ticket_size_upto = tsu
    },
    setRevenueFrom(state, rf){
      state.revenue_from = rf
    },
    setRevenueUpto(state, ru){
      state.revenue_upto = ru
    },
    setExeUsers(state, User){
      state.exeusers = User
    },
    setCities(state, User){
      state.cities = User
    },
    setSubProjects(state, User){
      state.subProjects = User
    },
    setThirdParties(state, tp){
      state.third_parties = tp
    },
    setMultiManager(state, mm){
      state.multiManger = mm
    },
    setRunoUser(state, ru){
      state.runo_user = ru
    },
    setisTodaysCall(state, tc){
      state.todays_call = tc
    },
    setIsStarProject(state, sp){
      state.is_star_project = sp
    },
    setEnquiry(state, eq){
      state.enquiry = eq
    },
    setActiveUser(state, au){
      state.active_user = au
    },
    setLoading(state, isLoading){
      state.isLoading = isLoading
    },
    setAdGroups(state, adGroupIds){
      state.selectedAdGroups = adGroupIds
    },
    setCampaigns(state, campaignIds){
      state.selectedCampaigns = campaignIds
    },
    setPhysicalPincode(state, pincode){
      state.physical_pincode = pincode;
    },
    setMtrFilters(state, filters){
      state.mtrReportFilters = filters;
    },
    setAdStrategies(state, strategies){
      state.ad_strategies = strategies;
    },
    setAdsNames(state, names){
      state.ads_names = names;
    },
    setDevices(state, devices){
      state.devices = devices;
    },
    setKeywordTypes(state, types){
      state.keyword_types = types;
    },
    setUtmCampaigns(state, campaigns){
      state.utm_campaigns = campaigns;
    }
  },
  actions: {
    setLayout({commit}, layout){
      commit('setLayout', layout);
    },
    setActiveItem({commit}, item){
      commit('setActiveItem', item);
    },
    setSubStatusActiveItem({commit}, item){
      commit('setSubStatusActiveItem', item);
    },
    setDefaultDates({commit}, dates){
      commit('setDefaultDates', dates);
    },
    setActiveTitle({commit}, title){
      commit('setActiveTitle', title);
    },
    setSelectedProjects({commit}, list){
      commit('setSelectedProjects', list);
    },
    addProject({commit}, project){
      commit('addProject', project);
    },
    removeProject({commit}, project){
      commit('removeProject', project);
    },
    setSelectedSources({commit}, list){
      commit('setSelectedSources', list);
    },
    setSelectedManager({commit}, managerId){
      commit('setSelectedManager', managerId);
    },
    setTakeRateFrom({commit}, trf){
      commit('setTakeRateFrom', trf);
    },
    setTakeRateUpto({commit}, tru){
      commit('setTakeRateUpto', tru);
    },
    setTicketSizeFrom({commit}, tsf){
      commit('setTicketSizeFrom', tsf);
    },
    setTicketSizeUpto({commit}, tsu){
      commit('setTicketSizeUpto', tsu);
    },
    setRevenueFrom({commit}, rf){
      commit('setRevenueFrom', rf);
    },
    setRevenueUpto({commit}, ru){
      commit('setRevenueUpto', ru);
    },

    setActiveUser({commit}, au){
      commit('setActiveUser', au);
    },
    setRunoUser({commit}, ru){
      commit('setRunoUser', ru);
    },
    setExeUsers({commit}, User){
      commit('setExeUsers', User);
    },
    setCities({commit}, User){
      commit('setCities', User);
    },
    setSubProjects({commit}, User){
      commit('setSubProjects', User);
    },
    setAdGroups({commit}, User){
      commit('setAdGroups', User);
    },
    setCampaigns({commit}, User){
      commit('setCampaigns', User);
    },
    setisTodaysCall({commit}, tc){
      commit('setisTodaysCall', tc);
    },
    setIsStarProject({commit}, sp){
      commit('setIsStarProject', sp);
    },
    setEnquiry({commit}, eq){
      commit('setEnquiry', eq);
    },
    setPhysicalPincode({commit}, pincode){
      commit('setPhysicalPincode', pincode);
    },
    setMtrFilters({commit}, filters){
      commit('setMtrFilters', filters);
    },
    setAdStrategies({commit}, strategies){
      commit('setAdStrategies', strategies);
    },
    setAdsNames({commit}, names){
      commit('setAdsNames', names);
    },
    setDevices({commit}, devices){
      commit('setDevices', devices);
    },
    setKeywordTypes({commit}, types){
      commit('setKeywordTypes', types);
    },
    setUtmCampaigns({commit}, campaigns){
      commit('setUtmCampaigns', campaigns);
    },
    clearFilters({commit}){
      commit('setSelectedProjects', [])
      commit('setSelectedManager', null)
      commit('setExecutive', null)
      commit('setSelectedSources', [])
      commit('setSubStatus', [])
      commit('setStatus', [])
      commit('setExeUsers', [])
      commit('setCities', [])
      commit('setSubProjects', [])
      commit('setAdGroups', [])
      commit('setCampaigns', [])
      commit('setThirdParties', [])
      commit('setMultiManager', [])
      commit('setRunoUser', '')
      commit('setisTodaysCall', '')
      commit('setEnquiry', '')
      commit('setTakeRateFrom', null)
      commit('setTakeRateUpto', null)
      commit('setTicketSizeFrom', null)
      commit('setTicketSizeUpto', null)
      commit('setRevenueFrom', null)
      commit('setRevenueUpto', null)
      commit('setActiveUser', null)
      commit('setPhysicalPincode', [])
      commit('setAdStrategies', [])
      commit('setAdsNames', [])
      commit('setDevices', [])
      commit('setKeywordTypes', [])
      commit('setUtmCampaigns', [])
      // commit('setIsStarProject', false)
    },
    setExecutive({commit}, execid){
      commit('setExecutive', execid);
    },
    setSubStatus({commit}, ss){
      commit('setSubStatus', ss);
    },
    setStatus({commit}, s){
      commit('setStatus', s);
    },
    setThirdParties({commit}, tp){
      commit('setThirdParties', tp);
    },
    setMultiManager({commit}, mm){
      commit('setMultiManager', mm);
    },
    setLoading({commit}, isLoading){
      commit('setLoading', isLoading);
    }
  },
  getters: {
    layout(state){
      return state.layoutName;
    },
    activeItem(state){
      return state.activeItem;
    },
    defaultDates(state){
      return state.selectedDates;
    },
    activeSubStatusItem(state){
      return state.activeSubStatusItem;
    },
    activeTitle(state){
      return state.activeTitle;
    },
    sDefaults(state){
      return state.sDefaults;
    },
    eDefaults(state){
      return state.eDefaults;
    },
    uDefaults(state){
      return state.uDefaults;
    },
    selectedProjects(state){
      return state.selectedProjects;
    },
    selectedProjectIds(state){
      return state.selectedProjects.map(project=>project.id);
    },
    selectedSources(state){
      return state.selectedSources;
    },
    selectedManager(state){
      return state.selectedManager;
    },
    executive(state){
      return state.executive;
    },
    substatus(state){
      return state.substatus;
    },
    status(state){
      return state.status;
    },
    exeusers(state){
      return state.exeusers;
    },
    third_parties(state){
      return state.third_parties;
    },
    multiManger(state){
      return state.multiManger;
    },
    todays_call(state){
      return state.todays_call;
    },
    is_star_project(state){
      return state.is_star_project;
    },
    runo_user(state){
      return state.runo_user;
    },
    enquiry(state){
      return state.enquiry;
    },
    take_rate_from(state){
      return state.take_rate_from;
    },
    take_rate_upto(state){
      return state.take_rate_upto;
    },
    average_ticket_size_from(state){
      return state.average_ticket_size_from;
    },
    average_ticket_size_upto(state){
      return state.average_ticket_size_upto;
    },
    revenue_from(state){
      return state.revenue_from;
    },
    revenue_upto(state){
      return state.revenue_upto;
    },
    user_active(state){
      return state.active_user;
    },
    isLoading(state){
      return state.isLoading;
    },
    cities(state){
      return state.cities;
    },
    subProjects(state){
      return state.subProjects;
    },
    adGroups(state){
      return state.selectedAdGroups;
    },
    campaigns(state){
      return state.selectedCampaigns;
    },
    physicalPincode(state){
      return state.physical_pincode;
    },
    mtrReportFilters(state){
      return state.mtrReportFilters;
    },
    adStrategies(state){
      return state.ad_strategies;
    },
    adsNames(state){
      return state.ads_names;
    },
    devices(state){
      return state.devices;
    },
    keywordTypes(state){
      return state.keyword_types;
    },
    utmCampaigns(state){
      return state.utm_campaigns;
    }
  },
  plugins: [createPersistedState({
    key: 'leadItem',
    paths: ['activeItem'],
  })],
})
